import { render } from "./ChristmasQuizCompleteWrongPage.vue?vue&type=template&id=1e1beefe&scoped=true"
import script from "./ChristmasQuizCompleteWrongPage.vue?vue&type=script&lang=js"
export * from "./ChristmasQuizCompleteWrongPage.vue?vue&type=script&lang=js"

import "./ChristmasQuizCompleteWrongPage.vue?vue&type=style&index=0&id=1e1beefe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1beefe"]])

export default __exports__